{
  "replaceMessage": "Slipp filen for å erstatte"
}
